import { render, staticRenderFns } from "./Menu2.vue?vue&type=template&id=4e2787ce&scoped=true"
import script from "./Menu2.vue?vue&type=script&lang=js"
export * from "./Menu2.vue?vue&type=script&lang=js"
import style0 from "./Menu2.vue?vue&type=style&index=0&id=4e2787ce&prod&scoped=true&lang=css"
import style1 from "./Menu2.vue?vue&type=style&index=1&id=4e2787ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2787ce",
  null
  
)

export default component.exports